import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Howto convince the iStore you're from the US and circumvent regional copyright restrictions",
  "description": "",
  "published": "2009-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/howto-convince-the-istore-youre-from-the-us/swizec/824"],
  "categories": "Apple, Business, life, Uncategorized, United States",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Green_copyright.svg"
          }}><figure parentName="a" {...{
              "className": "gatsby-resp-image-figure",
              "style": {
                "textAlign": "center",
                "fontStyle": "italic"
              }
            }}>{`
    `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "197px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "100%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M179%201l-9%202a216%20216%200%2000-85%2034l-8%206a256%20256%200%2000-47%2052%20202%20202%200%2000-16%20177l3%206a200%20200%200%2000281%2094%20383%20383%200%200031-21%20179%20179%200%200043-53%20205%20205%200%200025-126A198%20198%200%2000179%201m1%2041a159%20159%200%201040%20315%20159%20159%200%2000-40-315m8%2048a112%20112%200%201049%20217%20102%20102%200%200025-12c4%200%2024-20%2031-30%209-13%2017-31%2016-36%200-2-13-3-50-2l-5%205a61%2061%200%2001-80%2023%2062%2062%200%2001-32-64c6-31%2030-50%2060-50%2022%200%2039%209%2052%2029l4%206h51v-2a110%20110%200%2000-86-83c-6-1-26-2-35-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/c55f956f5367fcbf28527ed4094d8e4a/07b9d/Copyrightedh1cc38.webp 197w"],
                    "sizes": "(max-width: 197px) 100vw, 197px",
                    "type": "image/webp"
                  }}></source>{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/c55f956f5367fcbf28527ed4094d8e4a/1c154/Copyrightedh1cc38.png 197w"],
                    "sizes": "(max-width: 197px) 100vw, 197px",
                    "type": "image/png"
                  }}></source>{`
          `}<img parentName="picture" {...{
                    "className": "gatsby-resp-image-image",
                    "src": "/static/c55f956f5367fcbf28527ed4094d8e4a/1c154/Copyrightedh1cc38.png",
                    "alt": "Copyrighted",
                    "title": "Copyrighted",
                    "loading": "lazy",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    }
                  }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
                "className": "gatsby-resp-image-figcaption"
              }}>{`Copyrighted`}</figcaption>{`
  `}</figure></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Green_copyright.svg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Yesterday somebody shared a cool podcast with me.`}</p>
    <p>{`Well I should say they tried to, thing is, I didn't have an iStore account. But whatever, I'll just make one right? Well ... no. That particular podcast is only available in the US due to copyright restrictions or something, or maybe it's just that most of the store is US only, but whatever. Thing is, I had to make an account and I had to make an American one. Not a Slovene one.`}</p>
    <p>{`No biggie right, go to the iStore, make an account.`}</p>
    <p>{`Well no, you can't choose where you're from.`}</p>
    <p>{`So let's change the language/locale to US and voila, american store. HEY even paypal is available now (yes we've got PayPal in Slovenia but Apple is an idiot and doesn't aknowledge this fact).`}</p>
    <p>{`Yay, choose paypal, make account. Nope, says I'm not from the US. Fine, I'll give you my credit card info ... well fuck you mister Swizec, credit card says you're not american. Fail.`}</p>
    <p>{`This is the process I had to go through to have a valid US Apple ID and iStore account.`}</p>
    <ol>
      <li parentName="ol">{`Find a free App.`}</li>
      <li parentName="ol">{`Download App.`}</li>
      <li parentName="ol">{`Create account`}</li>
      <li parentName="ol">{`Choose without CreditCard (they can't demand payment info for free downloads, some legal stuff afaik)`}</li>
      <li parentName="ol">{`Enter some US address found on google maps (I used `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/M5_Industries",
          "title": "M5 Industries"
        }}>{`M5 Industries`}</a>{` because `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/MythBusters",
          "title": "MythBusters"
        }}>{`Mythbusters`}</a>{` is made there and I love Mythbusters). Btw this isn't identity theft because you use your own name.`}</li>
      <li parentName="ol">{`Rejoice, you have a valid US iStore account`}</li>
    </ol>
    <p>{`Great! I can now download `}<strong parentName="p">{`FREE`}</strong>{` stuff that is, for some strange and utterly absurd reason, only available in the US. Why have region restricted copyright when the content is bloody free is ... can anyone explain this at all?`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/b7015c77-1a4f-4945-97ad-10b5f0edea2f/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=b7015c77-1a4f-4945-97ad-10b5f0edea2f",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      